import { render, staticRenderFns } from "./m-face-verify.vue?vue&type=template&id=99336c60&scoped=true&"
import script from "./m-face-verify.vue?vue&type=script&lang=js&"
export * from "./m-face-verify.vue?vue&type=script&lang=js&"
import style0 from "./m-face-verify.vue?vue&type=style&index=0&id=99336c60&prod&ref=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99336c60",
  null
  
)

export default component.exports